import React from "react";
import classNames from "classnames";
import { WrappedFieldInputProps } from "redux-form";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label?: string;
  input?: Partial<WrappedFieldInputProps>;
  with_text?: boolean;
  disabled?: boolean;
}

const Switch: React.FC<Props> = (props: Props): JSX.Element => {
  const { id, label, with_text, disabled, input, ...rest } = props;

  const formElemRootClasses = classNames(
    "caprx-f-elem-root",
    "caprx-f-elem-selection-container",
    { "caprx-f-elem-switch-with-text": with_text },
    { "caprx-f-elem-disabled": disabled },
  );

  return (
    <div className={formElemRootClasses}>
      <label htmlFor={id} className="caprx-f-elem-switch">
        <input id={id} type="checkbox" disabled={disabled} {...input} {...rest} />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default Switch;
